import React from 'react';

const T = ({ children, ...props }) => (
  <svg viewBox="0 0 400 225" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid slice" {...props}>
    {children}
  </svg>
);

const TitleBar = ({ title, genre }) => (
  <>
    <rect x="0" y="188" width="400" height="37" fill="rgba(0,0,0,0.72)" />
    <text x="12" y="210" fontFamily="monospace" fontWeight="bold" fontSize="13" fill="white" letterSpacing="1">{title}</text>
    {genre && (
      <>
        <rect x="344" y="193" width={52} height="18" rx="9" fill="rgba(255,255,255,0.12)" />
        <text x="370" y="206" textAnchor="middle" fontFamily="sans-serif" fontSize="9" fill="rgba(255,255,255,0.8)">{genre}</text>
      </>
    )}
  </>
);

const thumbnails = {
  'savanna-warriors': () => (
    <T>
      <defs>
        <linearGradient id="sw" x1="0" y1="0" x2="1" y2="1"><stop stopColor="#ff6b35"/><stop offset="1" stopColor="#f7931e"/></linearGradient>
      </defs>
      <rect width="400" height="225" fill="url(#sw)" />
      <circle cx="310" cy="52" r="42" fill="#FFD700" opacity="0.92" />
      <ellipse cx="310" cy="52" rx="52" ry="52" fill="#FF8C00" opacity="0.35" />
      <rect x="0" y="158" width="400" height="67" fill="#3d1a00" opacity="0.8" />
      <rect x="0" y="152" width="400" height="10" fill="#556B2F" opacity="0.9" />
      {/* acacia left */}
      <rect x="52" y="112" width="9" height="50" fill="#2a1200" />
      <ellipse cx="57" cy="103" rx="38" ry="17" fill="#1a3300" />
      {/* acacia right */}
      <rect x="318" y="128" width="7" height="35" fill="#2a1200" />
      <ellipse cx="322" cy="120" rx="30" ry="13" fill="#1a3300" />
      {/* warrior */}
      <circle cx="190" cy="98" r="14" fill="rgba(0,0,0,0.88)" />
      <rect x="183" y="111" width="14" height="48" fill="rgba(0,0,0,0.88)" />
      <line x1="198" y1="88" x2="216" y2="44" stroke="#8B6914" strokeWidth="3.5" />
      <polygon points="216,44 210,58 222,58" fill="#ddd" />
      <ellipse cx="179" cy="121" rx="9" ry="16" fill="#C0392B" opacity="0.9" />
      <TitleBar title="SAVANNA WARRIORS" genre="RPG" />
    </T>
  ),

  'kilimanjaro-quest': () => (
    <T>
      <defs>
        <linearGradient id="kq" x1="0" y1="0" x2="0" y2="1"><stop stopColor="#0a4a3a"/><stop offset="0.4" stopColor="#00d4aa"/><stop offset="1" stopColor="#006644"/></linearGradient>
        <linearGradient id="kqsky" x1="0" y1="0" x2="0" y2="1"><stop stopColor="#0a2a4a"/><stop offset="1" stopColor="#00d4aa"/></linearGradient>
      </defs>
      <rect width="400" height="225" fill="url(#kqsky)" />
      {/* clouds */}
      <ellipse cx="80" cy="50" rx="55" ry="20" fill="white" opacity="0.15" />
      <ellipse cx="300" cy="40" rx="70" ry="22" fill="white" opacity="0.12" />
      {/* stars */}
      {[30,70,120,180,240,280,340,380].map((x,i) => (
        <circle key={i} cx={x} cy={15 + (i%3)*12} r="1.5" fill="white" opacity="0.6" />
      ))}
      {/* mountain */}
      <polygon points="200,20 80,185 320,185" fill="#5a6a7a" />
      <polygon points="200,20 155,90 245,90" fill="white" opacity="0.9" />
      {/* forest belt */}
      <rect x="0" y="168" width="400" height="20" fill="#1a4a1a" opacity="0.9" />
      {/* ground */}
      <rect x="0" y="182" width="400" height="43" fill="#0a2a0a" />
      {/* snow glow */}
      <ellipse cx="200" cy="55" rx="50" ry="20" fill="white" opacity="0.1" />
      <TitleBar title="KILIMANJARO QUEST" genre="ADV" />
    </T>
  ),

  'swahili-legends': () => (
    <T>
      <defs>
        <linearGradient id="sl" x1="0" y1="0" x2="0" y2="1"><stop stopColor="#1a0030"/><stop offset="0.6" stopColor="#9b59b6"/><stop offset="1" stopColor="#3a0060"/></linearGradient>
        <linearGradient id="slsea" x1="0" y1="0" x2="0" y2="1"><stop stopColor="#2d0050"/><stop offset="1" stopColor="#0a0020"/></linearGradient>
      </defs>
      <rect width="400" height="225" fill="url(#sl)" />
      {/* stars */}
      {[20,55,90,130,170,210,255,290,330,370,40,150,300].map((x,i) => (
        <circle key={i} cx={x} cy={10 + (i%5)*18} r={i%3===0?2:1.5} fill="white" opacity={0.5 + (i%3)*0.2} />
      ))}
      {/* moon */}
      <circle cx="330" cy="45" r="28" fill="#FFF5CC" opacity="0.95" />
      <circle cx="344" cy="38" r="22" fill="#1a0030" opacity="0.9" />
      {/* ocean */}
      <rect x="0" y="148" width="400" height="77" fill="url(#slsea)" />
      {/* waves */}
      <path d="M0,152 Q50,142 100,152 Q150,162 200,152 Q250,142 300,152 Q350,162 400,152" fill="none" stroke="#9b59b6" strokeWidth="2" opacity="0.5" />
      <path d="M0,162 Q50,152 100,162 Q150,172 200,162 Q250,152 300,162 Q350,172 400,162" fill="none" stroke="#7a3a9a" strokeWidth="1.5" opacity="0.4" />
      {/* dhow hull */}
      <path d="M130,148 Q200,120 270,148 L260,160 Q200,170 140,160 Z" fill="#1a0a00" />
      {/* mast */}
      <line x1="200" y1="55" x2="200" y2="148" stroke="#8B6914" strokeWidth="3" />
      {/* sail */}
      <polygon points="200,60 200,140 265,115" fill="white" opacity="0.9" />
      <polygon points="200,70 200,130 140,108" fill="white" opacity="0.75" />
      <TitleBar title="SWAHILI LEGENDS" genre="ACT" />
    </T>
  ),

  'zanzibar-mysteries': () => (
    <T>
      <defs>
        <linearGradient id="zm" x1="0" y1="0" x2="0" y2="1"><stop stopColor="#020b1a"/><stop offset="1" stopColor="#1a3560"/></linearGradient>
      </defs>
      <rect width="400" height="225" fill="url(#zm)" />
      {/* stars */}
      {[30,80,140,200,260,320,370,50,170,300].map((x,i) => (
        <circle key={i} cx={x} cy={8+(i%4)*15} r="1.5" fill="white" opacity="0.5" />
      ))}
      {/* stone town door arch */}
      <rect x="148" y="60" width="104" height="128" rx="52" fill="#0a1520" />
      <rect x="160" y="72" width="80" height="116" rx="40" fill="#051020" />
      {/* door frame decoration */}
      <rect x="148" y="60" width="104" height="128" rx="52" fill="none" stroke="#3498db" strokeWidth="2" opacity="0.6" />
      {/* door panels */}
      <rect x="166" y="120" width="32" height="60" rx="4" fill="#0a1a2a" stroke="#2a5080" strokeWidth="1" />
      <rect x="202" y="120" width="32" height="60" rx="4" fill="#0a1a2a" stroke="#2a5080" strokeWidth="1" />
      {/* lantern */}
      <rect x="192" y="35" width="16" height="22" rx="3" fill="#FFD700" opacity="0.85" />
      <line x1="200" y1="20" x2="200" y2="35" stroke="#888" strokeWidth="2" />
      <ellipse cx="200" cy="57" rx="25" ry="10" fill="#FFD700" opacity="0.2" />
      {/* question marks */}
      <text x="80" y="110" fontFamily="serif" fontSize="36" fill="#3498db" opacity="0.3">?</text>
      <text x="300" y="90" fontFamily="serif" fontSize="28" fill="#3498db" opacity="0.25">?</text>
      <text x="340" y="140" fontFamily="serif" fontSize="20" fill="#3498db" opacity="0.2">?</text>
      <TitleBar title="ZANZIBAR MYSTERIES" genre="VR" />
    </T>
  ),

  'maasai-runners': () => (
    <T>
      <defs>
        <linearGradient id="mr" x1="0" y1="0" x2="1" y2="0"><stop stopColor="#e74c3c"/><stop offset="1" stopColor="#c0392b"/></linearGradient>
        <linearGradient id="mrsky" x1="0" y1="0" x2="0" y2="1"><stop stopColor="#c0392b"/><stop offset="1" stopColor="#e74c3c" /></linearGradient>
      </defs>
      <rect width="400" height="225" fill="url(#mrsky)" />
      {/* sun at horizon */}
      <ellipse cx="200" cy="140" rx="220" ry="45" fill="#ff6b35" opacity="0.3" />
      <circle cx="200" cy="155" r="38" fill="#FFD700" opacity="0.7" />
      {/* horizon line */}
      <rect x="0" y="155" width="400" height="70" fill="#8B4513" opacity="0.6" />
      <rect x="0" y="150" width="400" height="8" fill="#556B2F" opacity="0.7" />
      {/* speed lines */}
      {[20,45,70,95,115].map((y,i) => (
        <line key={i} x1="0" y1={y} x2={120-(i*8)} y2={y} stroke="white" strokeWidth="1.5" opacity={0.08+(i*0.04)} />
      ))}
      {/* dotted trail */}
      {[60,90,120,150].map((x,i) => (
        <circle key={i} cx={x} cy={130+(i*4)} r="4" fill="white" opacity={0.3+(i*0.1)} />
      ))}
      {/* runner silhouette - mid stride */}
      <circle cx="220" cy="85" r="16" fill="rgba(0,0,0,0.85)" />
      {/* torso */}
      <rect x="212" y="100" width="16" height="38" fill="rgba(0,0,0,0.85)" rx="4" />
      {/* legs */}
      <line x1="218" y1="138" x2="200" y2="165" stroke="rgba(0,0,0,0.85)" strokeWidth="10" strokeLinecap="round" />
      <line x1="226" y1="138" x2="248" y2="158" stroke="rgba(0,0,0,0.85)" strokeWidth="10" strokeLinecap="round" />
      {/* arms */}
      <line x1="212" y1="108" x2="192" y2="122" stroke="rgba(0,0,0,0.85)" strokeWidth="8" strokeLinecap="round" />
      <line x1="228" y1="108" x2="248" y2="95" stroke="rgba(0,0,0,0.85)" strokeWidth="8" strokeLinecap="round" />
      <TitleBar title="MAASAI RUNNERS" genre="RUN" />
    </T>
  ),

  'ngorongoro-tactics': () => (
    <T>
      <defs>
        <linearGradient id="nt" x1="0" y1="0" x2="1" y2="1"><stop stopColor="#f39c12"/><stop offset="1" stopColor="#d35400"/></linearGradient>
      </defs>
      <rect width="400" height="225" fill="url(#nt)" />
      {/* grid overlay */}
      {[0,1,2,3,4,5].map(i => (
        <line key={`h${i}`} x1="0" y1={37.5*i} x2="400" y2={37.5*i} stroke="white" strokeWidth="0.5" opacity="0.12" />
      ))}
      {[0,1,2,3,4,5,6,7].map(i => (
        <line key={`v${i}`} x1={50*i} y1="0" x2={50*i} y2="225" stroke="white" strokeWidth="0.5" opacity="0.12" />
      ))}
      {/* crater outline */}
      <circle cx="200" cy="100" r="80" fill="none" stroke="white" strokeWidth="2.5" opacity="0.4" />
      <circle cx="200" cy="100" r="80" fill="#c87000" opacity="0.15" />
      {/* inner crater detail */}
      <circle cx="200" cy="100" r="55" fill="none" stroke="white" strokeWidth="1.5" opacity="0.25" />
      <circle cx="200" cy="100" r="30" fill="rgba(0,80,0,0.4)" />
      {/* lake in crater center */}
      <ellipse cx="200" cy="105" rx="18" ry="12" fill="#1a6090" opacity="0.8" />
      {/* animal/chess piece icons */}
      <text x="150" y="82" fontSize="18" textAnchor="middle">🦁</text>
      <text x="250" y="82" fontSize="18" textAnchor="middle">🐘</text>
      <text x="200" y="65" fontSize="14" textAnchor="middle">🦒</text>
      {/* tactical arrows */}
      <path d="M168,95 L152,80" stroke="#FFD700" strokeWidth="2" markerEnd="url(#arr)" opacity="0.7" />
      <path d="M232,95 L248,80" stroke="#FFD700" strokeWidth="2" opacity="0.7" />
      <TitleBar title="NGORONGORO TACTICS" genre="STR" />
    </T>
  ),

  'drums-of-war': () => (
    <T>
      <defs>
        <linearGradient id="dw" x1="0" y1="0" x2="0" y2="1"><stop stopColor="#1a0030"/><stop offset="0.5" stopColor="#8b5cf6"/><stop offset="1" stopColor="#3a0060"/></linearGradient>
        <radialGradient id="dfire" cx="50%" cy="100%"><stop stopColor="#ff6b00"/><stop offset="1" stopColor="#ff6b00" stopOpacity="0"/></radialGradient>
      </defs>
      <rect width="400" height="225" fill="url(#dw)" />
      <rect x="0" y="170" width="400" height="55" fill="url(#dfire)" opacity="0.5" />
      {/* fire flames */}
      <path d="M150,185 Q160,155 170,175 Q180,148 190,172 Q200,140 210,168 Q220,145 230,172 Q240,155 250,180" fill="none" stroke="#ff6b35" strokeWidth="3" opacity="0.8" />
      <path d="M160,190 Q170,165 180,182 Q190,158 200,178 Q210,162 220,180 Q230,168 240,185" fill="none" stroke="#FFD700" strokeWidth="2" opacity="0.7" />
      {/* drum */}
      <ellipse cx="200" cy="130" rx="55" ry="22" fill="#4a2a00" stroke="#8B6914" strokeWidth="2" />
      <rect x="145" y="130" width="110" height="40" fill="#5a3a10" />
      <ellipse cx="200" cy="170" rx="55" ry="18" fill="#4a2a00" stroke="#8B6914" strokeWidth="2" />
      {/* tribal lines on drum */}
      <line x1="165" y1="128" x2="162" y2="170" stroke="#8B6914" strokeWidth="1.5" />
      <line x1="185" y1="128" x2="183" y2="170" stroke="#8B6914" strokeWidth="1.5" />
      <line x1="215" y1="128" x2="217" y2="170" stroke="#8B6914" strokeWidth="1.5" />
      <line x1="235" y1="128" x2="238" y2="170" stroke="#8B6914" strokeWidth="1.5" />
      {/* crossed spears */}
      <line x1="100" y1="50" x2="300" y2="180" stroke="#8B6914" strokeWidth="4" opacity="0.7" />
      <line x1="300" y1="50" x2="100" y2="180" stroke="#8B6914" strokeWidth="4" opacity="0.7" />
      <circle cx="200" cy="115" r="16" fill="#6d28d9" stroke="#8b5cf6" strokeWidth="2" />
      <text x="200" y="121" textAnchor="middle" fontSize="14" fill="#FFD700">👑</text>
      <TitleBar title="DRUMS OF WAR: KINGDOMS" genre="RTS" />
    </T>
  ),

  'safari-kart': () => (
    <T>
      <defs>
        <linearGradient id="sk" x1="0" y1="0" x2="0" y2="1"><stop stopColor="#1a4a20"/><stop offset="1" stopColor="#10b981"/></linearGradient>
      </defs>
      <rect width="400" height="225" fill="url(#sk)" />
      {/* sky */}
      <rect x="0" y="0" width="400" height="100" fill="#1a5a40" opacity="0.5" />
      {/* track curve */}
      <path d="M0,180 Q100,120 200,170 Q300,220 400,160" fill="none" stroke="#888" strokeWidth="40" opacity="0.8" />
      <path d="M0,180 Q100,120 200,170 Q300,220 400,160" fill="none" stroke="#aaa" strokeWidth="36" opacity="0.6" />
      {/* track markings */}
      {[0.1,0.3,0.5,0.7,0.9].map((t,i) => {
        const x = t * 400;
        const y = 155 + Math.sin(t * Math.PI) * 25;
        return <line key={i} x1={x} y1={y-6} x2={x} y2={y+6} stroke="white" strokeWidth="3" opacity="0.7" />;
      })}
      {/* palm trees */}
      <rect x="30" y="80" width="7" height="65" fill="#5a3010" />
      <ellipse cx="33" cy="75" rx="28" ry="14" fill="#1a5a10" />
      <rect x="355" y="90" width="6" height="55" fill="#5a3010" />
      <ellipse cx="358" cy="85" rx="24" ry="12" fill="#1a5a10" />
      {/* kart body */}
      <rect x="158" y="128" width="85" height="38" rx="8" fill="#ff6b35" />
      <rect x="148" y="140" width="105" height="20" rx="6" fill="#cc4411" />
      {/* wheels */}
      <circle cx="172" cy="168" r="14" fill="#222" stroke="#555" strokeWidth="3" />
      <circle cx="228" cy="168" r="14" fill="#222" stroke="#555" strokeWidth="3" />
      <circle cx="172" cy="168" r="6" fill="#555" />
      <circle cx="228" cy="168" r="6" fill="#555" />
      {/* driver */}
      <circle cx="200" cy="126" r="11" fill="#FFD700" />
      {/* checkered flag */}
      <rect x="348" y="40" width="28" height="20" fill="none" stroke="#FFD700" strokeWidth="1.5" />
      {[0,1,2,3].map(i => [0,1,2,3].map(j => (
        <rect key={`${i}${j}`} x={348+i*7} y={40+j*5} width="7" height="5" fill={(i+j)%2===0?"white":"black"} opacity="0.9" />
      )))}
      <line x1="362" y1="30" x2="362" y2="60" stroke="#888" strokeWidth="2" />
      <TitleBar title="SAFARI KART" genre="RACE" />
    </T>
  ),

  'spirit-caller': () => (
    <T>
      <defs>
        <radialGradient id="sc"><stop stopColor="#ff80b0"/><stop offset="1" stopColor="#be185d"/></radialGradient>
        <radialGradient id="scglow" cx="50%" cy="50%"><stop stopColor="#ff80ff" stopOpacity="0.6"/><stop offset="1" stopColor="#be185d" stopOpacity="0"/></radialGradient>
      </defs>
      <rect width="400" height="225" fill="#1a0020" />
      <ellipse cx="200" cy="110" rx="130" ry="100" fill="url(#scglow)" />
      {/* mystical particles */}
      {[40,80,120,160,200,240,280,320,360,20,100,180,260,340].map((x,i) => (
        <circle key={i} cx={x} cy={15+(i%5)*20} r={i%2===0?2:1.5} fill="#ff80b0" opacity={0.3+(i%3)*0.2} />
      ))}
      {/* cards fanned out */}
      {[
        {x:130,y:95,r:-25,c:"#1a3a6a",bc:"#2a5aaa"},
        {x:155,y:80,r:-12,c:"#1a2a6a",bc:"#3a4aaa"},
        {x:182,y:72,r:0,c:"#2a1a6a",bc:"#5a4aaa"},
        {x:210,y:78,r:12,c:"#4a1a6a",bc:"#7a3aaa"},
        {x:234,y:92,r:24,c:"#5a1a4a",bc:"#8a3a8a"},
      ].map((card,i) => (
        <g key={i} transform={`rotate(${card.r}, ${card.x+30}, 160)`}>
          <rect x={card.x} y={card.y} width="60" height="90" rx="6" fill={card.c} stroke={card.bc} strokeWidth="1.5" />
          <text x={card.x+30} y={card.y+50} textAnchor="middle" fontSize="22">
            {['⚡','🌙','🌟','🔥','💎'][i]}
          </text>
        </g>
      ))}
      {/* central glowing orb */}
      <circle cx="200" cy="115" r="24" fill="#ff80b0" opacity="0.25" />
      <circle cx="200" cy="115" r="14" fill="#ff80ff" opacity="0.5" />
      <circle cx="200" cy="115" r="7" fill="white" opacity="0.9" />
      {/* swirl rings */}
      <circle cx="200" cy="115" r="40" fill="none" stroke="#ff80b0" strokeWidth="1.5" strokeDasharray="6,4" opacity="0.4" />
      <circle cx="200" cy="115" r="60" fill="none" stroke="#be185d" strokeWidth="1" strokeDasharray="4,6" opacity="0.25" />
      <TitleBar title="SPIRIT CALLER" genre="CARD" />
    </T>
  ),

  'baobab-village': () => (
    <T>
      <defs>
        <linearGradient id="bv" x1="0" y1="0" x2="0" y2="1"><stop stopColor="#f97316"/><stop offset="0.4" stopColor="#84cc16"/><stop offset="1" stopColor="#166534"/></linearGradient>
      </defs>
      <rect width="400" height="225" fill="#f97316" />
      <rect x="0" y="0" width="400" height="130" fill="#f97316" />
      <rect x="0" y="130" width="400" height="95" fill="#166534" />
      <rect x="0" y="125" width="400" height="12" fill="#22c55e" />
      {/* sun */}
      <circle cx="340" cy="55" r="38" fill="#FFD700" opacity="0.95" />
      {/* birds */}
      <path d="M60,45 Q65,40 70,45 Q75,40 80,45" fill="none" stroke="#1a0a00" strokeWidth="2" opacity="0.6" />
      <path d="M100,30 Q105,25 110,30 Q115,25 120,30" fill="none" stroke="#1a0a00" strokeWidth="1.5" opacity="0.5" />
      {/* baobab trunk */}
      <rect x="175" y="60" width="50" height="90" rx="10" fill="#5a3010" />
      <rect x="185" y="65" width="30" height="80" fill="#6a3a14" />
      {/* baobab crown */}
      <ellipse cx="200" cy="48" rx="75" ry="30" fill="#3a6010" />
      <ellipse cx="160" cy="60" rx="40" ry="22" fill="#2a5010" />
      <ellipse cx="240" cy="62" rx="38" ry="20" fill="#2a5010" />
      <ellipse cx="200" cy="35" rx="55" ry="22" fill="#4a7020" />
      {/* branches */}
      <line x1="200" y1="65" x2="155" y2="45" stroke="#5a3010" strokeWidth="5" />
      <line x1="200" y1="65" x2="245" y2="48" stroke="#5a3010" strokeWidth="5" />
      {/* huts */}
      {[[60,155],[110,160],[280,152],[330,158]].map(([x,y],i) => (
        <g key={i}>
          <polygon points={`${x},${y} ${x-22},${y+20} ${x+22},${y+20}`} fill="#c87000" />
          <rect x={x-18} y={y+18} width="36" height="20" fill="#a06000" />
        </g>
      ))}
      <TitleBar title="BAOBAB VILLAGE" genre="SIM" />
    </T>
  ),

  'nyama-choma-tycoon': () => (
    <T>
      <defs>
        <linearGradient id="nc" x1="0" y1="0" x2="0" y2="1"><stop stopColor="#1a0800"/><stop offset="1" stopColor="#f97316"/></linearGradient>
        <radialGradient id="ncfire" cx="50%" cy="100%"><stop stopColor="#ff4400"/><stop offset="1" stopColor="#ff4400" stopOpacity="0"/></radialGradient>
      </defs>
      <rect width="400" height="225" fill="url(#nc)" />
      <rect x="0" y="130" width="400" height="95" fill="url(#ncfire)" opacity="0.6" />
      {/* grill legs */}
      <line x1="145" y1="145" x2="130" y2="185" stroke="#444" strokeWidth="6" />
      <line x1="255" y1="145" x2="270" y2="185" stroke="#444" strokeWidth="6" />
      {/* grill body */}
      <ellipse cx="200" cy="130" rx="80" ry="22" fill="#333" stroke="#555" strokeWidth="2" />
      <rect x="120" y="130" width="160" height="20" fill="#2a2a2a" />
      <ellipse cx="200" cy="150" rx="80" ry="22" fill="#333" stroke="#555" strokeWidth="2" />
      {/* grill grates */}
      {[-40,-20,0,20,40].map(x => (
        <line key={x} x1={200+x} y1={128} x2={200+x} y2={152} stroke="#555" strokeWidth="2" />
      ))}
      {/* meat/food on grill */}
      {[155,180,210,240].map((x,i) => (
        <ellipse key={i} cx={x} cy={130} rx={i%2===0?16:12} ry="7" fill={i%2===0?"#8B4513":"#c87000"} />
      ))}
      {/* flames */}
      <path d="M145,150 Q155,120 165,145 Q175,115 185,142 Q195,110 205,140 Q215,115 225,142 Q235,122 245,148 Q255,125 265,152" fill="none" stroke="#ff4400" strokeWidth="3" opacity="0.9" />
      <path d="M150,155 Q160,130 170,150 Q180,125 190,148 Q200,120 210,145 Q220,128 230,150 Q240,132 250,155" fill="none" stroke="#FFD700" strokeWidth="2" opacity="0.8" />
      {/* chef hat */}
      <rect x="187" y="30" width="26" height="35" rx="4" fill="white" />
      <ellipse cx="200" cy="30" rx="22" ry="10" fill="white" />
      <ellipse cx="200" cy="22" rx="14" ry="12" fill="white" />
      {/* coins */}
      <circle cx="55" cy="80" r="14" fill="#FFD700" stroke="#c8a000" strokeWidth="2" />
      <text x="55" y="85" textAnchor="middle" fontSize="12" fill="#5a4000" fontWeight="bold">$</text>
      <circle cx="85" cy="65" r="10" fill="#FFD700" stroke="#c8a000" strokeWidth="2" />
      <TitleBar title="NYAMA CHOMA TYCOON" genre="TYC" />
    </T>
  ),

  'lake-tanganyika': () => (
    <T>
      <defs>
        <linearGradient id="lt" x1="0" y1="0" x2="0" y2="1"><stop stopColor="#0a1a3a"/><stop offset="0.5" stopColor="#0891b2"/><stop offset="1" stopColor="#0a4a5a"/></linearGradient>
        <linearGradient id="ltdeep" x1="0" y1="0" x2="0" y2="1"><stop stopColor="#0a4a5a"/><stop offset="1" stopColor="#020a14"/></linearGradient>
      </defs>
      <rect width="400" height="225" fill="url(#lt)" />
      {/* surface shimmer */}
      <rect x="0" y="0" width="400" height="88" fill="#0a2a5a" opacity="0.4" />
      {/* water surface line */}
      <path d="M0,88 Q100,78 200,88 Q300,98 400,88" fill="rgba(255,255,255,0.15)" />
      <path d="M0,88 Q50,82 100,88 Q150,94 200,88 Q250,82 300,88 Q350,94 400,88 L400,225 L0,225 Z" fill="url(#ltdeep)" />
      {/* light rays from surface */}
      {[80,130,180,230,280,330].map((x,i) => (
        <line key={i} x1={x} y1="88" x2={x+20} y2="220" stroke="white" strokeWidth="1.5" opacity="0.04" />
      ))}
      {/* bubbles */}
      {[60,100,140,180,220,260,300,340].map((x,i) => (
        <circle key={i} cx={x} cy={100+(i*12)%80} r={2+(i%3)} fill="none" stroke="white" strokeWidth="1" opacity={0.3+(i%3)*0.1} />
      ))}
      {/* fish silhouettes */}
      <path d="M80,120 Q110,110 140,120 Q110,130 80,120 Z" fill="white" opacity="0.6" />
      <polygon points="80,120 65,115 65,125" fill="white" opacity="0.6" />
      <path d="M230,145 Q265,133 300,145 Q265,157 230,145 Z" fill="white" opacity="0.5" />
      <polygon points="230,145 213,139 213,151" fill="white" opacity="0.5" />
      <path d="M140,175 Q165,165 190,175 Q165,185 140,175 Z" fill="white" opacity="0.4" />
      <polygon points="140,175 126,169 126,181" fill="white" opacity="0.4" />
      <path d="M290,165 Q310,157 330,165 Q310,173 290,165 Z" fill="white" opacity="0.5" />
      <polygon points="290,165 278,160 278,170" fill="white" opacity="0.5" />
      {/* coral/plant at bottom */}
      <line x1="50" y1="225" x2="40" y2="195" stroke="#1a8a4a" strokeWidth="4" />
      <ellipse cx="40" cy="192" rx="12" ry="8" fill="#1a8a4a" />
      <line x1="330" y1="225" x2="345" y2="200" stroke="#1a6a3a" strokeWidth="3" />
      <ellipse cx="345" cy="197" rx="10" ry="7" fill="#1a6a3a" />
      <TitleBar title="LAKE TANGANYIKA" genre="EXP" />
    </T>
  ),

  'tinga-tinga-tales-adventure': () => (
    <T>
      <defs>
        <linearGradient id="tt" x1="0" y1="0" x2="1" y2="1"><stop stopColor="#fbbf24"/><stop offset="1" stopColor="#f59e0b"/></linearGradient>
      </defs>
      <rect width="400" height="225" fill="url(#tt)" />
      {/* colorful dot pattern (Tinga Tinga style) */}
      {[30,70,110,150,190,230,270,310,350].map((x,i) => (
        ['#ff4400','#0044ff','#00aa44','#ff0088','#8800ff'].map((c,j) => (
          <circle key={`${i}${j}`} cx={x+(j*5)} cy={20+(i*18)%90} r="5" fill={c} opacity="0.35" />
        ))
      ))}
      {/* big sun */}
      <circle cx="60" cy="48" r="32" fill="#FF6B00" opacity="0.9" />
      {[0,45,90,135,180,225,270,315].map((a,i) => (
        <line key={i} x1={60+Math.cos(a*Math.PI/180)*34} y1={48+Math.sin(a*Math.PI/180)*34}
          x2={60+Math.cos(a*Math.PI/180)*44} y2={48+Math.sin(a*Math.PI/180)*44}
          stroke="#FF6B00" strokeWidth="3" />
      ))}
      {/* Tinga Tinga elephant - round geometric style */}
      <circle cx="220" cy="115" r="58" fill="#6699aa" />
      <circle cx="180" cy="100" r="20" fill="#6699aa" /> {/* head */}
      <ellipse cx="160" cy="115" rx="8" ry="28" fill="#6699aa" /> {/* trunk */}
      {/* spots on elephant (Tinga Tinga style) */}
      {[[205,95,'#88bbdd'],[240,110,'#4477aa'],[215,130,'#88bbdd'],[230,85,'#4477aa']].map(([x,y,c],i) => (
        <circle key={i} cx={x} cy={y} r="12" fill={c} opacity="0.8" />
      ))}
      {/* eye */}
      <circle cx="174" cy="97" r="5" fill="#222" />
      <circle cx="175" cy="96" r="2" fill="white" />
      {/* colorful decorative dots around elephant */}
      {[[140,60,'#ff4400'],[280,70,'#0044ff'],[310,130,'#00aa44'],[145,150,'#ff0088'],[290,165,'#8800ff']].map(([x,y,c],i) => (
        <circle key={i} cx={x} cy={y} r="8" fill={c} opacity="0.6" />
      ))}
      <TitleBar title="TINGA TINGA TALES" genre="EDU" />
    </T>
  ),

  'urban-beats-dar': () => (
    <T>
      <defs>
        <linearGradient id="ub" x1="0" y1="0" x2="0" y2="1"><stop stopColor="#1a0030"/><stop offset="1" stopColor="#7c3aed"/></linearGradient>
      </defs>
      <rect width="400" height="225" fill="url(#ub)" />
      {/* city skyline silhouette */}
      <rect x="0" y="120" width="400" height="68" fill="rgba(0,0,0,0.7)" />
      {[[30,70],[60,50],[90,80],[120,45],[150,65],[180,30],[210,55],[240,75],[270,40],[300,60],[330,80],[360,50],[385,70]].map(([x,h],i) => (
        <rect key={i} x={x-15} y={120-h} width="28" height={h} fill="#0a0010" opacity="0.9" />
      ))}
      {/* window lights in buildings */}
      {[[35,90],[65,75],[100,100],[125,70],[185,60],[215,80],[275,65]].map(([x,y],i) => (
        <rect key={i} x={x} y={y} width="5" height="5" fill="#FFD700" opacity={0.5+(i%3)*0.2} />
      ))}
      {/* sound wave */}
      <path d="M20,60 Q60,20 100,60 Q140,100 180,60 Q220,20 260,60 Q300,100 340,60 Q370,30 390,50" fill="none" stroke="#a855f7" strokeWidth="3" opacity="0.7" />
      {/* music notes */}
      <text x="80" y="50" fontSize="28" opacity="0.85">♪</text>
      <text x="190" y="38" fontSize="34" opacity="0.9">♫</text>
      <text x="300" y="52" fontSize="26" opacity="0.8">♩</text>
      {/* equalizer bars */}
      {[20,36,52,68,84].map((x,i) => {
        const h = [30,50,25,45,35][i];
        return <rect key={i} x={310+x} y={75-h} width="12" height={h} rx="3" fill="#a855f7" opacity={0.5+(i%2)*0.3} />;
      })}
      <TitleBar title="URBAN BEATS: DAR" genre="RHTM" />
    </T>
  ),

  'serengeti-survival': () => (
    <T>
      <defs>
        <linearGradient id="ss" x1="0" y1="0" x2="0" y2="1"><stop stopColor="#8b4513"/><stop offset="0.4" stopColor="#cd853f"/><stop offset="1" stopColor="#556B2F"/></linearGradient>
      </defs>
      <rect width="400" height="225" fill="url(#ss)" />
      {/* sunset sky */}
      <rect x="0" y="0" width="400" height="110" fill="#c0392b" opacity="0.55" />
      {/* sun at horizon */}
      <circle cx="200" cy="118" r="42" fill="#FF8C00" opacity="0.8" />
      <ellipse cx="200" cy="118" rx="55" ry="30" fill="#FF6B00" opacity="0.3" />
      {/* horizon ground */}
      <rect x="0" y="115" width="400" height="110" fill="#556B2F" opacity="0.8" />
      <rect x="0" y="150" width="400" height="75" fill="#3d4a20" />
      {/* grass tufts */}
      {[20,65,100,145,200,255,300,350,380].map((x,i) => (
        <g key={i}>
          <line x1={x} y1="150" x2={x-5} y2="135" stroke="#4a5a20" strokeWidth="2.5" />
          <line x1={x+6} y1="150" x2={x+3} y2="133" stroke="#5a6a28" strokeWidth="2" />
          <line x1={x+12} y1="150" x2={x+14} y2="137" stroke="#4a5a20" strokeWidth="2" />
        </g>
      ))}
      {/* lion silhouette (large, left) */}
      <ellipse cx="130" cy="133" rx="52" ry="30" fill="rgba(0,0,0,0.85)" />
      <circle cx="165" cy="118" r="22" fill="rgba(0,0,0,0.85)" />
      {/* mane */}
      <circle cx="163" cy="118" r="28" fill="rgba(30,15,0,0.7)" />
      {/* legs */}
      <rect x="100" y="155" width="14" height="25" rx="7" fill="rgba(0,0,0,0.85)" />
      <rect x="120" y="158" width="14" height="22" rx="7" fill="rgba(0,0,0,0.85)" />
      <rect x="148" y="157" width="14" height="22" rx="7" fill="rgba(0,0,0,0.85)" />
      <rect x="168" y="155" width="14" height="25" rx="7" fill="rgba(0,0,0,0.85)" />
      {/* wildebeest (right, smaller) */}
      <ellipse cx="298" cy="140" rx="32" ry="18" fill="rgba(0,0,0,0.7)" />
      <circle cx="325" cy="130" r="14" fill="rgba(0,0,0,0.7)" />
      <rect x="285" y="155" width="9" height="18" rx="4" fill="rgba(0,0,0,0.7)" />
      <rect x="302" y="157" width="9" height="16" rx="4" fill="rgba(0,0,0,0.7)" />
      <TitleBar title="SERENGETI SURVIVAL" genre="SIM" />
    </T>
  ),

  'dhow-traders': () => (
    <T>
      <defs>
        <linearGradient id="dt" x1="0" y1="0" x2="0" y2="1"><stop stopColor="#0a1a4a"/><stop offset="0.5" stopColor="#0ea5e9"/><stop offset="1" stopColor="#0a4a6a"/></linearGradient>
      </defs>
      <rect width="400" height="225" fill="url(#dt)" />
      {/* sky with stars */}
      {[30,80,140,200,260,320,370,50,170,300].map((x,i) => (
        <circle key={i} cx={x} cy={8+(i%4)*14} r="1.5" fill="white" opacity={0.4+(i%3)*0.2} />
      ))}
      {/* moon */}
      <circle cx="350" cy="40" r="22" fill="#FFF5CC" opacity="0.8" />
      {/* ocean waves */}
      <path d="M0,138 Q50,128 100,138 Q150,148 200,138 Q250,128 300,138 Q350,148 400,138 L400,225 L0,225 Z" fill="#0a2a5a" opacity="0.9" />
      <path d="M0,148 Q40,138 80,148 Q120,158 160,148 Q200,138 240,148 Q280,158 320,148 Q360,138 400,148" fill="none" stroke="#1a6a9a" strokeWidth="2" opacity="0.5" />
      {/* dhow hull */}
      <path d="M100,138 Q200,115 300,138 L285,160 Q200,172 115,160 Z" fill="#2a1400" stroke="#8B6914" strokeWidth="1.5" />
      {/* mast */}
      <line x1="200" y1="40" x2="200" y2="138" stroke="#8B6914" strokeWidth="4" />
      {/* main sail */}
      <polygon points="200,45 200,132 295,95" fill="white" opacity="0.92" />
      <polygon points="200,55 200,120 115,90" fill="#f5f5e8" opacity="0.8" />
      {/* cargo/deck */}
      {[[145,150],[165,152],[185,151],[215,152],[235,150]].map(([x,y],i) => (
        <rect key={i} x={x} y={y} width="14" height="10" rx="2" fill="#8B6914" opacity="0.8" />
      ))}
      {/* compass rose */}
      <circle cx="55" cy="68" r="22" fill="rgba(0,0,0,0.4)" stroke="#FFD700" strokeWidth="1.5" />
      {['N','S','E','W'].map((d,i) => {
        const a = i * 90 * Math.PI / 180;
        return <text key={d} x={55+Math.sin(a)*14} y={68-Math.cos(a)*14+4} textAnchor="middle" fontSize="8" fill="#FFD700" fontWeight="bold">{d}</text>;
      })}
      {/* gold coins */}
      <circle cx="330" cy="155" r="9" fill="#FFD700" stroke="#c8a000" strokeWidth="1.5" />
      <circle cx="348" cy="162" r="7" fill="#FFD700" stroke="#c8a000" strokeWidth="1" />
      <circle cx="316" cy="164" r="6" fill="#FFD700" stroke="#c8a000" strokeWidth="1" />
      <TitleBar title="DHOW TRADERS" genre="STR" />
    </T>
  ),
};

const DefaultThumbnail = ({ game }) => (
  <T>
    <defs>
      <linearGradient id="def" x1="0" y1="0" x2="1" y2="1">
        <stop stopColor="#ff6b35" />
        <stop offset="1" stopColor="#00d4aa" />
      </linearGradient>
    </defs>
    <rect width="400" height="225" fill="url(#def)" />
    <text x="200" y="100" textAnchor="middle" fontFamily="monospace" fontWeight="bold" fontSize="48" fill="rgba(0,0,0,0.25)">RB</text>
    <TitleBar title={game.title.toUpperCase()} genre={game.genres?.[0] || ''} />
  </T>
);

const GameThumbnail = ({ game, className = '' }) => {
  const ThumbnailComponent = thumbnails[game.slug];
  return (
    <div className={`overflow-hidden ${className}`}>
      {ThumbnailComponent ? (
        <ThumbnailComponent />
      ) : (
        <DefaultThumbnail game={game} />
      )}
    </div>
  );
};

export default GameThumbnail;
